import { render, staticRenderFns } from "./AlertTemplate.vue?vue&type=template&id=3114aa33&scoped=true"
import script from "./AlertTemplate.vue?vue&type=script&lang=js"
export * from "./AlertTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114aa33",
  null
  
)

export default component.exports